import React from 'react';
import { Input } from '../../../components/ui';

const DocumentNumberField = ({ type, formData, generatingNumber }) => (
  <Input
    id="scNumber"
    name="scNumber"
    label={`${type === 'PM' ? 'PM' : 'SR'} number`}
    value={generatingNumber ? 'Generating…' : formData.scNumber}
    readOnly
    disabled
    placeholder={`Auto-generated ${type} number`}
    hint={`Generated automatically from the existing ${type} sequence.`}
    className="[&_input]:font-mono"
  />
);

export default DocumentNumberField;
